var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCandidates = function SvgIconCandidates(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5047ff",
    d: "M8.4 11.6a4.8 4.8 0 1 0-4.8-4.8 4.8 4.8 0 0 0 4.8 4.8m1.9 1.8H6.5A6.5 6.5 0 0 0 0 19.9a1.3 1.3 0 0 0 1.3 1.3h14.2a1.3 1.3 0 0 0 1.3-1.3 6.5 6.5 0 0 0-6.5-6.5m12.8-3.9h-1.8V7.7a.9.9 0 1 0-1.8 0v1.8h-1.8a.9.9 0 0 0 0 1.8h1.8v1.8a.9.9 0 1 0 1.8 0v-1.8h1.8a.9.9 0 0 0 0-1.8",
    "data-name": "Group 1787"
  })));
};
export default SvgIconCandidates;